import { render, staticRenderFns } from "./EditarCapacitacion.vue?vue&type=template&id=4be58669&scoped=true"
import script from "./EditarCapacitacion.vue?vue&type=script&lang=js"
export * from "./EditarCapacitacion.vue?vue&type=script&lang=js"
import style0 from "./EditarCapacitacion.vue?vue&type=style&index=0&id=4be58669&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be58669",
  null
  
)

export default component.exports